module.exports = __webpack_public_path__ + "static/img/official-examination-center-2025.bdc4532.png";


//////////////////
// WEBPACK FOOTER
// /Users/hissin/classover/app/build-artifacts/official-examination-center-2025.png
// module id = QaB0
// module chunks = 1